"use client";

import React from "react";
import Link from "next/link";
import styles from "./Button.module.css";

type ButtonVariant = "primary" | "secondary" | "outline" | "ghost";
type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  href?: string;
  onClick?: () => void;
  "aria-label"?: string;
}

export default function Button({
  children,
  variant = "primary",
  size = "md",
  href,
  onClick,
  className = "",
  "aria-label": ariaLabel,
  ...props
}: ButtonProps) {
  const buttonClasses = `${styles.btn} ${styles[`btn-${variant}`]} ${styles[`btn-${size}`]} ${className}`;

  // Nếu có href, render như Link
  if (href) {
    return (
      <Link href={href as any}>
        <button
          className={buttonClasses}
          onClick={onClick}
          aria-label={ariaLabel}
          {...props}
        >
          {children}
        </button>
      </Link>
    );
  }

  // Nếu không có href, render như button thông thường
  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </button>
  );
}
